var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWgCompletionAge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.75,
    cy: 6.25,
    r: 0.75,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.75,
    cy: 17.75,
    r: 0.75,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.75,
    cy: 8,
    r: 0.75,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.25,
    cy: 11.75,
    r: 0.75,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.75,
    cy: 11.75,
    r: 0.75,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.75,
    cy: 15.75,
    r: 0.75,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.75,
    cy: 15.75,
    r: 0.75,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2216 8.07079C15.6841 7.67287 16.3206 8.29219 15.9356 8.76538L12.2127 13.3403C12.0274 13.568 11.6867 13.5878 11.4762 13.3831L10.7281 12.6553C10.5177 12.4505 10.5281 12.1094 10.7507 11.9179L15.2216 8.07079Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWgCompletionAge);
export default __webpack_public_path__ + "static/media/wg_completion_age.71d22766c08933c1c05c938ed3296835.svg";
export { ForwardRef as ReactComponent };